import {UserOutlined} from '@ant-design/icons'
import {Avatar, Badge, Dropdown, Menu, Modal} from 'antd'
import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {useHistory} from 'react-router'
import accountApi from 'src/component/app/account/AccountApi'
import {useUser} from 'src/context/UserContext'

interface Props {

}

export const ProfileMenu: React.FC<Props> = () => {

    const [count] = useState(0)

    const history = useHistory()

    const { user } = useUser()

    const logout = () =>
        Modal.confirm({
            title: 'Logout',
            content: 'Are you sure?',
            cancelText: 'NO',
            okText: 'Yes, I\'m sure',
            onOk: () => {
                accountApi.logout().then(success => {
                    if (success) {
                        history.push('/')
                    }
                })
            }
        })

    const menu = (
        <Menu selectable={false}>
            <Menu.Item>
                <div className="rfq__widget__system-status__item">
                    <strong>Hello, </strong>{user?.username}
                    <div>
                        <strong>Role: </strong>{user?.role}
                        <br />
                    </div>
                </div>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Divider />
                <Menu.Item>
                    <Link to={`/account/${user?.id}/edit`}>
                        <i className="topbar__dropdownMenuIcon icmn-user" /> Edit Profile
                    </Link>
                </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="logout" onClick={logout}>
                <a>
                    <i className="topbar__dropdownMenuIcon icmn-exit" /> Logout
                </a>
            </Menu.Item>
        </Menu>
    )
    return (
        <div className="topbar__dropdown d-inline-block">
            <Dropdown
                overlay={menu}
                trigger={['click']}
                placement="bottomRight"
            >
                {/* <a className="ant-dropdown-link" href="/"> */}
                    <Badge count={count} className='cursor-pointer'>
                        <Avatar className="topbar__avatar" shape="square" size="large" icon={<UserOutlined />} />
                    </Badge>
                {/* </a> */}
            </Dropdown>
        </div>
    )
}

export default ProfileMenu
